import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7500Model } from "../kymw7500.model";

type GetBuyerListForCheckPlanNumResponse = {
  Code: string;
  Name: string;
}[];

/**
 * バイヤーの選択肢を取得するサービス
 *
 * @export GetBuyerListForCheckPlanNumService
 * @class GetBuyerListForCheckPlanNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBuyerListForCheckPlanNumService extends PlessJsonResponderSub<GetBuyerListForCheckPlanNumResponse> {
  private model: KYMW7500Model;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBuyerListForCheckPlanNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetBuyerListForCheckPlanNumService
   */
  execute(model: KYMW7500Model, successFunc?: () => void) {
    this.model = model;
    this.successFunc = successFunc;
    // /KYMW12/getBuyerSelectItemsを呼び出す
    this.send('getBuyerSelectItems', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetBuyerListForCheckPlanNumService 
   */
  success(data: GetBuyerListForCheckPlanNumResponse) {
    this.model.buyerList = [
      // blankを追加
      { code: '', name: '' },
      ...data.map(buyer => ({
        code: buyer.Code,
        name: `${buyer.Code}:${buyer.Name}`
      }))];

    if (!!this.successFunc) {
      this.successFunc();
    }
  }
} 